// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2a2ZM","question":"Question_question__3UeVs","description":"Question_description__1kvc6"};